import { z } from "zod";
import {
  notificationTypeSchema,
  subscriptionParametersUnknownRecordSchema,
  subscriptionRoleSchema,
} from "../_shared";

export const emailSubscriptionsPerCompanyItemSchema = z.object({
  uuid: z.uuid(),
  company: z.uuid(),
  type: notificationTypeSchema,
  role: subscriptionRoleSchema,
  parameters: subscriptionParametersUnknownRecordSchema,
});

export const emailSubscriptionsPerCompanyResponseSchema = z.array(
  emailSubscriptionsPerCompanyItemSchema,
);

export type EmailSubscriptionsPerCompanyItem = z.infer<
  typeof emailSubscriptionsPerCompanyItemSchema
>;
export type EmailSubscriptionsPerCompanyResponse = z.infer<
  typeof emailSubscriptionsPerCompanyResponseSchema
>;
